var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiGetOneProffitSearchGroupAdminStatus, apiGetProffitSearchGroupAccountStatus, } from '../../../actions/ProffitSearchGroupAction';
import { apiGetOneProffitSearchShareStatus } from '../../../actions/ProffitSearchShareAction';
import { apiGetProffitSearchTrialInviteStatus } from '../../../actions/ProffitSearchTrialAction';
import { BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_ACCOUNT, BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_OTHER_ORGANIZATION, BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_ROLE, BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_OTHER_GROUP, BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_SAME, BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_DISABLE_ACCOUNT, BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_OTHER_ORGANIZATION, BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_TRIAL, BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_USER, BAD_PROFFIT_SEARCH_ACCOUNT_CANT_SHARE_SLIDE_ACCOUNT, BAD_PROFFIT_SEARCH_ACCOUNT_CANT_SHARE_SLIDE_OTHER_ORGANIZATION, } from '../../../define/response';
import { wrapDispatch } from '../../../helpers/action';
import { getErrorFromErrorObject } from '../../../helpers/validate';
/**
 * スタンダードプランのメンバー追加の非同期バリデーション
 * @param dispatch
 * @param email
 * @param fieldName
 * @returns {Promise<{fieldName, hasEnableAccount: boolean, error: string, email}>}
 */
export const validateAccountStatus = (dispatch, email, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
    const result = {
        email,
        error: '',
        fieldName,
        hasEnableAccount: false,
    };
    try {
        const { payload } = yield wrapDispatch(dispatch, apiGetProffitSearchGroupAccountStatus({ email }));
        result.hasEnableAccount = payload.hasEnableAccount;
    }
    catch (e) {
        const { code } = getErrorFromErrorObject(e);
        result.error =
            {
                [BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_DISABLE_ACCOUNT]: '無効化済みのアカウントです',
                [BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_OTHER_ORGANIZATION]: '招待できない組織に所属しているアカウントです',
                [BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_USER]: 'このメールアドレスは利用できません',
            }[code] ||
                'システムエラーが発生しました。しばらく時間を置いてからやり直すか、管理者にお問い合わせください。';
    }
    return result;
});
/**
 * スタンダードプランの請求先追加の非同期バリデーション
 * @param dispatch
 * @param email
 * @param fieldName
 * @returns {Promise<{fieldName, error: string, email}>}
 */
export const validateAdminAccountStatus = (dispatch, email, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
    const result = {
        email,
        error: '',
        fieldName,
    };
    try {
        yield wrapDispatch(dispatch, apiGetOneProffitSearchGroupAdminStatus({ admin_email: email }));
    }
    catch (e) {
        const { code } = getErrorFromErrorObject(e);
        result.error =
            {
                [BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_ACCOUNT]: 'このメールアドレスは利用できません',
                [BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_OTHER_GROUP]: 'こちらのアドレスを責任者にされたい場合、責任者もしくはそのチームのメンバーに招待してもらう必要があります。詳細はサポートまでお問い合わせください',
                [BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_OTHER_ORGANIZATION]: '招待できない組織に所属しているアカウントです',
                [BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_ROLE]: '責任者ではないため選択できません。詳細はサポートまでお問い合わせください',
                [BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_SAME]: 'メールアドレスが変更されていません',
            }[code] ||
                'システムエラーが発生しました。しばらく時間を置いてからやり直すか、管理者にお問い合わせください。';
    }
    return result;
});
/**
 * トライアル招待の非同期バリデーション
 * @param dispatch
 * @param email
 * @param fieldName
 * @returns {Promise<{fieldName, error: string, email}>}
 */
export const validateTrialStatus = (dispatch, email, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
    const result = {
        email,
        error: '',
        fieldName,
    };
    if (!email) {
        return result;
    }
    try {
        yield wrapDispatch(dispatch, apiGetProffitSearchTrialInviteStatus({ email }));
    }
    catch (e) {
        const { code } = getErrorFromErrorObject(e);
        result.error =
            {
                [BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_TRIAL]: '既に登録済みのアドレスです',
            }[code] ||
                'システムエラーが発生しました。しばらく時間を置いてからやり直すか、管理者にお問い合わせください。';
    }
    return result;
});
/**
 * スライド共有の非同期バリデーション
 * @param dispatch
 * @param email
 * @param fieldName
 * @returns {Promise<{fieldName, error: string, email}>}
 */
export const validateShareStatus = (dispatch, email, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
    const result = {
        email,
        error: '',
        fieldName,
    };
    try {
        yield wrapDispatch(dispatch, apiGetOneProffitSearchShareStatus({ email }));
    }
    catch (e) {
        const { code } = getErrorFromErrorObject(e);
        result.error =
            {
                [BAD_PROFFIT_SEARCH_ACCOUNT_CANT_SHARE_SLIDE_ACCOUNT]: 'このメールアドレスは利用できません',
                [BAD_PROFFIT_SEARCH_ACCOUNT_CANT_SHARE_SLIDE_OTHER_ORGANIZATION]: '組織外のアドレスです',
            }[code] ||
                'システムエラーが発生しました。しばらく時間を置いてからやり直すか、管理者にお問い合わせください。';
    }
    return result;
});
